<template>
  <div class="container">
    <PreviousNavLink previous-label="Tillbaka"></PreviousNavLink>
    <div class="row">
      <div class="col-lg-8">
        <h1 class="page-header">Visa och underteckna överenskommelse och PUB-avtal</h1>
        <p class="intro">När du är redo att underteckna PUB-avtal och Överenskommelse behöver du ange kontaktpersoner
          för biträdesavtal och dataskydd. Du kommer sedan underteckna med enkel elektronisk signatur (SES Simple
          Electronic Signature).
          <router-link :to="`/organisation/${orgId}/avtal/`">Här kan du läsa mer om Överenskommelse och PUB-avtal
          </router-link>
        </p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-lg-6">
        <OrderList
          :data="{title:'Undertecknandet har tre steg:', items:['Ange kontaktpersoner för PUB-avtal och dataskydd','Bekräfta överenskommelse', 'Bekräfta PUB-avtal och underteckna']}" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <CtaPanel>
          <div class="buttons-container spread-buttons">
            <PreviousNavLink previous-label="Tillbaka"></PreviousNavLink>
            <router-link
              :to="`/organisation/${orgId}/avtal/kontakt`"
              class="btn btn-light">Börja undertecknande &nbsp;<span
              class="fas fa-chevron-right"></span>
            </router-link>
          </div>
        </CtaPanel>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CtaPanel from "../components/CtaPanel.vue";
import { useRoute } from "vue-router";
import OrderList from "@/components/OrderList.vue";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

export default defineComponent({
  name: "OrgAgreementConfirmStep1",
  components: {
    CtaPanel,
    OrderList,
    PreviousNavLink
  },
  setup() {
    const route = useRoute();
    const { orgId } = route.params;

    return {
      orgId
    };
  }
});
</script>

<style lang="scss" scoped>
</style>